/**
 * @generated SignedSource<<3c08144edf62291afbd26bc5633e778a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReferAFriend_referralsRef_qmee$data = {
  readonly referralHistory: {
    readonly lifetime: {
      readonly earnings: {
        readonly currency: string;
        readonly subUnitAmount: number;
      } | null;
      readonly successes: number;
    };
  };
  readonly referralLink: string | null;
  readonly " $fragmentType": "ReferAFriend_referralsRef_qmee";
};
export type ReferAFriend_referralsRef_qmee$key = {
  readonly " $data"?: ReferAFriend_referralsRef_qmee$data;
  readonly " $fragmentSpreads": FragmentRefs<"ReferAFriend_referralsRef_qmee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ReferAFriend_referralsRef_qmee",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ReferralHistory",
      "kind": "LinkedField",
      "name": "referralHistory",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReferralsStats",
          "kind": "LinkedField",
          "name": "lifetime",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "successes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "CurrencyAmount",
              "kind": "LinkedField",
              "name": "earnings",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "subUnitAmount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "currency",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "referralLink",
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "8f3dbe845f597b7d6ba2d51c506e47c3";

export default node;
